/**
 * ?????????API ???? ????.
 * axios ??????????(src/api/index.js)?????????? ????????,
 * ??? ????? index.js ??????????????? ???????? Authorization ???????????????.
 *
 * ????? ???: axios ??????????????? 401 ?????? ??? ????, ?????????????????? ???.
 */
import api from './index'

/* ================================================================
 * ????? API
 * ================================================================ */

/**
 * ????? ?? ???? (??????????+ ?????????).
 *
 * @param {Object} params - { keyword, loginType, deleteYn, page, size }
 * @returns {Promise} { code, message, data: { items, total, page, size, totalPages } }
 */
export function getMemberList(params) {
  return api.get('/api/v1/member', { params })
}

/**
 * ????? ????? ????.
 * ????? + ?????????+ ???? ?? + ????? ???????????????? ?????.
 *
 * @param {string} userCode - ??????????
 * @returns {Promise} { code, message, data: { ...?????, siteEmail, oauthList, accounts, assets } }
 */
export function getMemberDetail(userCode) {
  return api.get(`/api/v1/member/${userCode}`)
}

/**
 * ????? ???.
 * user ???????? ?? ????????????? (?????????? ???????????????????????).
 *
 * @param {Object} data - { name, phone?, branchCode? }
 * @returns {Promise} ???????????? ????? ?????
 */
export function createMember(data) {
  return api.post('/api/v1/member', data)
}

/**
 * ????? ??? ????.
 * ????, ????? ?????????????? ?????????.
 *
 * @param {string} userCode - ????????????????
 * @param {Object} data - { name, phone?, branchCode? }
 * @returns {Promise} ??????????? ????? ?????
 */
export function updateMember(userCode, data) {
  return api.put(`/api/v1/member/${userCode}`, data)
}

/**
 * ????? ???? (soft delete).
 * delete_yn='Y', delete_dt=NOW() ???.
 *
 * @param {string} userCode - ????????????????
 * @returns {Promise} { code, message }
 */
export function deleteMember(userCode) {
  return api.delete(`/api/v1/member/${userCode}`)
}

/**
 * 회원 자산 입력/수정.
 * user_asset(KRW, POINT) upsert 및 user_metal_asset_summary 동기화.
 *
 * @param {string} userCode - 회원코드
 * @param {Object} data - { krwAmount: number, pointAmount: number }
 * @returns {Promise} 변경 후 회원 상세 응답
 */
export function updateMemberAsset(userCode, data) {
  return api.put(`/api/v1/member/${userCode}/asset`, data)
}
